/* eslint-disable import/first */
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'

// Plugins or Configs
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import vuetifyDialog from '@/configs/vuetifyDialog'
import '@/plugins/validations'
import '@/plugins/directives'
import '@/plugins/websocket'
import '@/configs/nprogress'
import '@/configs/debug'

// 3rd Party Packages
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VuePlyr from 'vue-plyr'
import VuetifyDialog from 'vuetify-dialog'

// Mixins
import locale from '@/mixins/global/locale'
import app from '@/mixins/global/app'
import user from '@/mixins/global/user'
import datetime from '@/mixins/global/datetime'
import storeApiDispatch from '@/mixins/global/storeApiDispatch'

// Others
import 'es6-promise/auto'

// CSS
import '@fortawesome/fontawesome-free/css/all.css'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import '@/assets/css/nprogress.css'
import '@/assets/css/main.css'

// Plugins Registration
Vue.use(VuePlyr)
Vue.use(VuetifyDialog, vuetifyDialog)

// Configuration
Vue.prototype.$API_URL = window.API_URL
Vue.config.productionTip = false
Vue.config.performance = true

// Component Registration
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

// GLobal Mixins Registrations
Vue.mixin(locale)
Vue.mixin(app)
Vue.mixin(user)
Vue.mixin(datetime)
Vue.mixin(storeApiDispatch)

// Temp Remove Sentry because https://orbit-life-enrichment.sentry.io/issues/5065007265/?project=4506907860140032&query=is%3Aunresolved&referrer=issue-stream&statsPeriod=14d&stream_index=0
// Sentry.init({
//   Vue,
//   dsn: 'https://95391e90bdd53840d8a0aebfc3c43e5b@o4506907858567168.ingest.us.sentry.io/4506907860140032',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false
//     })
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

/* eslint-disable no-new */
global.vue = new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
})
